import { Component } from '@angular/core';

@Component({
  selector: 'app-community-guidelines',
  templateUrl: './community-guidelines.html',
  styleUrls: ['./community-guidelines.scss']
})
export class CommunityGuidelinesComponent {}
